<!-- eslint-disable vue/no-v-for-template-key -->
 <!-- eslint-disable vue/no-v-for-template-key -->
<template>
  <div
    class="w-full rounded-lg border-2"
    style="border-color: #DEDEDE50;"
  >
    <div
      v-if="!isEditMode"
      :class="`w-full ${!isEditMode ? 'flex': 'hidden'} flex-col gap-5 p-1`"
      style="background-color: #DEDEDE50;"
    >
      <table
        class="w-full h-full relative p-4 space-y-5"
        style="background-color: #DEDEDE50;"
      >
        <thead>
          <tr>
            <th
              v-for="header in tableViewHeaders"
              :key="header.key"
              class="px-2 py-4"
            >
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(data, indexData) in tbsData">
            <tr  
              v-for="(detail, indexDetail) in data.details"
              :key="`${indexData}_${indexDetail}`"
              class="w-full font-normal"
              :class="indexDetail === data.details.length - 1 && 'border-b-4'"
              :style="indexDetail === data.details.length - 1 && 'border-color:#DEDEDE50'"
            >
              <td 
                v-if="indexDetail === 0"
                :key="`${indexData}_${indexDetail}_display_order`"
                :rowspan="data.details.length > 0 ? data.details.length : 1"
                class="px-2 py-2 bg-white rounded-tl-lg rounded-bl-lg"
              >
                {{ data.display_order }}
              </td>
              <td 
                v-if="indexDetail === 0"
                :key="`${indexData}_${indexDetail}_name`"
                :rowspan="data.details.length > 0 ? data.details.length : 1"
                class="px-2 py-2 bg-white rounded-tl-lg rounded-bl-lg"
              >
                {{ data.name }}
              </td>
              <!-- eslint-disable-next-line vue/no-v-for-template-key -->
              <template
                v-for="(th,thIndex) in tableViewHeaders.filter(h => h.key !== 'display_order' && h.key !== 'name')"
              >
                <td
                  :key="`${indexData}_${indexDetail}_${th.key}`"
                  class="px-2 py-2 bg-white border-white"
                  :class="thIndex === tableViewHeaders.filter(h => h.key !== 'display_order' && h.key !== 'name').length - 1 ? 'rounded-tr-lg rounded-br-lg' : ''"
                >
                  {{ getValue(detail,th.key) || data[th.key] }}
                </td>
              </template>
            </tr>
          </template>
          <!-- TOTAL QUANTITY -->
          <tr class="h-1 opacity-0" />
          <tr
            v-if="tbsDataList.length"
            class="bg-purple-200"
            style="border-color:#DEDEDE"
          >
            <td
              v-for="n in 4"
              :key="`${n}_first`"
              :class="n === 1 ? `rounded-tl-lg rounded-bl-lg`: ''"
            />
            <td class="font-semibold text-right px-2 py-3">
              Total Cargo Supply
            </td>
            <td class="font-semibold text-left p-2">
              {{ totalQty }}
            </td>
            <td class="rounded-tr-lg rounded-br-lg" />
          </tr>
          <tr
            v-if="!tbsDataList.length"
            class="bg-purple-200"
            style="border-color:#DEDEDE"
          >
            <td
              v-for="n in 2"
              :key="`${n}_second`"
              :class="n === 1 ? `rounded-tl-lg rounded-bl-lg`: ''"
            />
            <td class="font-semibold text-right px-2 py-3">
              No Data
              TBS has not been calculated/setup yet.
            </td>
            <td
              v-for="n in 4"
              :key="`${n}_third`"
              :class="n === 4 ? `rounded-tr-lg rounded-br-lg`: ''"
            />
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="isEditMode"
    >
      <tbs-blending-calculator-edit-table 
        :tbs-data-list="this.tbsData"
        :loading-plan-list="this.loadingPlanList"
        :set-payload-blending="this.setPayloadBlending"
        :set-error-list="this.setErrorList"
        :tbs-header-id="this.tbsHeaderId"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import TbsBlendingCalculatorEditTable from './TbsBlendingCalculatorEditTable.vue';
export default {
  components: { TbsBlendingCalculatorEditTable },
  computed: {
    totalQty() {
      return _.round(_.sumBy(this.tbsData,d => _.sumBy(d.details, 'quantity')),2)
    }
  },
  watch: {
    tbsDataList: {
      immediate:true,
      deep: true,
      handler(val) {
        this.tbsData = [...val.filter(t => t.blending_type === 'BLENDING')]
      }
    },
    loadingPlanList: {
      immediate: true,
      deep:true,
      handler(val) {
        this.loadingPlans = [...val]
      }
    }
  },
  data() {
    return {
      tableViewHeaders: [
        { label: 'No.', key: 'display_order'},
        { label: 'Blending Scheme', key: 'name'},
        { label: 'Trip Number', key: 'loading_plan_detail.barge_line_up.trip_number'},
        { label: 'Tug Name', key: 'loading_plan_detail.barge_line_up.tug'},
        { label: 'Barge Name', key: 'loading_plan_detail.barge_line_up.barge'},
        { label: 'Quantity', key: 'quantity'},
        { label: 'Product ID', key: 'loading_plan_detail.product'}
      ],
      tbsData: [],
      loadingPlans: []
    }
  },
  methods: {
    getValue(obj, path) {
      return path.split('.').reduce((acc, part) => acc?.[part], obj);
    }
  },
  props: {
    tbsHeaderId: {
      type: Number,
      default: () => null
    },
    tbsDataList: {
      type: Array,
      default: ()=> []
    },
    loadingPlanList: {
      type: Array,
      default: ()=> []
    },
    isEditMode: {
      type: Boolean,
      default: ()=> false
    },
    setPayloadBlending: {
      type: Function,
      default: () => {}
    },
    setErrorList: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style>
</style>